import { render, staticRenderFns } from "./index.vue?vue&type=template&id=742fd6ea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=742fd6ea&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742fd6ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('742fd6ea')) {
      api.createRecord('742fd6ea', component.options)
    } else {
      api.reload('742fd6ea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=742fd6ea&scoped=true", function () {
      api.rerender('742fd6ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wl-component-gallery/wl-attach/index.vue"
export default component.exports